// src/components/RequireAuth.jsx
// ✅ GOOGLE OAUTH VERSION

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/useAuth";

export default function RequireAuth({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  // ✅ UPDATED: Check for googleId instead of uid
  if (!user || !user.googleId) {
    return <Navigate to="/landing" state={{ from: location }} replace />;
  }

  return children;
}